







































































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import {
  GetQuestionList$,
  GetAllCates$,
  DeleteQuestions$,
} from "@/request/jxgl";
import Pagination from "@/components/paginaiton.vue";
import MainHeader from "../../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../components/left-nav.vue";
import QuestionTable from "./question-list.vue";
import AddCateDialog from "./add-cate-dialog.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    QuestionTable,
    Pagination,
    AddCateDialog,
  },
})
export default class XtkList extends Vue {
  private filters: any = {
    cate_id: "",
    题目难度: "",
    search: "",
    current_page: 1,
    total_count: 0,
    page_count: 10,
    order_value: 0,
  };
  // 选择
  private isIndeterminate: boolean = false;
  private checkAll: boolean = false;
  private selectedMessages: any[] = [];
  // 列表
  private questions: any[] = [];
  // 添加分类
  private cates: any[] = [];
  private ifShowAddCate: boolean = false;
  private setFilters() {
    localStorage.setItem("xtkListFilters", JSON.stringify(this.filters));
  }
  // 获得全部题型列表
  private fetchAllCate() {
    GetAllCates$(this).then((data) => {
      // console.log(data);
      this.cates = data;
    });
  }
  // 选中改变
  private selectChange(value, item) {
    if (item.selected) {
      this.selectedMessages.push(item);
      this.selectedMessages = _.uniqBy(this.selectedMessages, "question_id");
    } else {
      const index = _.findIndex(this.selectedMessages, "question_id");
      this.selectedMessages.splice(index, 1);
    }
  }
  /**
   * @description 跳转添加题目
   */
  private jumpDetail() {
    this.$router.push("/main/jxgl/xtk-detail");
  }
  /**
   * @description 打开添加分类
   */
  private openAddCate() {
    this.ifShowAddCate = true;
  }
  /**
   * @description 获得试题列表
   */
  private fetchQuestionList() {
    const params = _.cloneDeep(this.filters);
    GetQuestionList$(this, params).then((data: any) => {
      // console.log(data);
      data.questions.forEach((question: any) => {
        const inc = _.findIndex(this.selectedMessages, (i) => {
          return i["question_id"] === question["question_id"];
        });
        if (inc !== -1) {
          question["selected"] = true;
        } else {
          question["selected"] = false;
        }
      });
      this.$set(this, "questions", data.questions);
      this.filters.total_count = data.total_count;
      this.setFilters();
    });
  }
  /**
   * @description 改变排序顺序
   */
  private changeOrderValue() {
    this.filters.order_value = this.filters.order_value === 0 ? 1 : 0;
    this.search();
  }
  /**
   * @description 搜索
   */
  private search() {
    this.filters.current_page = 1;
    this.fetchQuestionList();
  }
  /**
   * @description 全选
   */
  private selectAll() {
    this.questions.forEach((question: any) => {
      question["selected"] = true;
      this.selectedMessages.push(question);
    });
    this.selectedMessages = _.uniqBy(this.selectedMessages, "question_id");
  }
  /**
   * @description 批量删除
   */
  private deleteThese() {
    this.$confirm("删除后将无法找回，您确定要删除么？", {
      title: "温馨提示",
    })
      .then((value) => {
        const arr: any[] = [];
        this.selectedMessages.forEach((item: any) => {
          arr.push(item.question_id);
        });
        const params: any = {
          data: {
            question_ids: arr,
          },
        };
        DeleteQuestions$(this, params).then((data: any) => {
          this.$message.success("删除成功");
          this.selectedMessages = [];
          this.search();
        });
      })
      .catch((err: any) => {
        console.log(err);
      });
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.filters.current_page = val;
    this.fetchQuestionList();
  }
  /**
   * @description 初始化
   */
  private mounted() {
    const localFilters = localStorage.getItem("xtkListFilters");
    if (!localFilters) {
      this.$set(this, "filters", {
        cate_id: "",
        题目难度: "",
        search: "",
        current_page: 1,
        page_count: 10,
        order_value: 0,
      });
    } else {
      this.$set(this, "filters", JSON.parse(localFilters));
    }
    this.fetchAllCate();
    this.fetchQuestionList();
  }
}
